import { Components, Theme } from "@mui/material";

export const MuiDialogContent: Components<
  Omit<Theme, "MuiDialogContent">
>["MuiDialogContent"] = {
  styleOverrides: {
    root: {
      paddingTop: 0,
    },
  },
};
